var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoutIcon = function SvgLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3487_7428)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41099 23.1051C2.88717 23.3591 1.5 22.184 1.5 20.6391L1.5 3.36097C1.5 1.81612 2.88717 0.641012 4.411 0.894984L12.411 2.22832C13.6165 2.42923 14.5 3.47221 14.5 4.6943L14.5 7.50005C14.5 7.77619 14.2761 8.00005 14 8.00005C13.7239 8.00005 13.5 7.77619 13.5 7.50005L13.5 4.6943C13.5 3.96104 12.9699 3.33526 12.2466 3.21471L4.2466 1.88138C3.3323 1.72899 2.5 2.43406 2.5 3.36097L2.5 20.6391C2.5 21.566 3.3323 22.2711 4.2466 22.1187L12.2466 20.7854C12.9699 20.6648 13.5 20.0391 13.5 19.3058L13.5 16.5C13.5 16.2239 13.7239 16 14 16C14.2761 16 14.5 16.2239 14.5 16.5L14.5 19.3058C14.5 20.5279 13.6165 21.5709 12.411 21.7718L4.41099 23.1051ZM18.1464 6.64651C17.9512 6.84177 17.9512 7.15835 18.1464 7.35362L22.2929 11.5001L7.00007 11.5001C6.72392 11.5001 6.50007 11.7239 6.50007 12.0001C6.50007 12.2762 6.72392 12.5001 7.00007 12.5001L22.2929 12.5001L18.1464 16.6465C17.9512 16.8418 17.9512 17.1584 18.1464 17.3536C18.3417 17.5489 18.6583 17.5489 18.8536 17.3536L23.8536 12.3536C24.0488 12.1584 24.0488 11.8418 23.8536 11.6465L18.8536 6.64651C18.6583 6.45125 18.3417 6.45125 18.1464 6.64651Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3487_7428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 24 0)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout_icon.7235fc8c.svg";
export { ForwardRef as ReactComponent };